<template>
  <div class="bg-white">
    <!-- Hero -->
    <section class="bg-[#111] text-white">
      <div class="max-w-screen-xl mx-auto px-6 py-14 lg:py-20 text-center">
        <p class="text-[0.875rem] font-semibold text-[#FFD500] mb-4 uppercase tracking-[0.06em]">
          <span aria-hidden="true">🧭</span> Keuzehulp
        </p>
        <h1 class="text-white text-[clamp(2rem,5vw,3.25rem)] font-black leading-[1.1] mb-4">
          Niet zeker wat je nodig hebt?
        </h1>
        <p class="text-[1.0625rem] sm:text-[1.1875rem] leading-[1.7] text-[#ccc] max-w-[620px] mx-auto">
          Beantwoord een paar korte vragen en we wijzen je direct naar de producten
          die het beste bij jouw situatie passen. Gratis, in minder dan een minuut.
        </p>
      </div>
    </section>

    <!-- Topic-kaarten -->
    <section class="max-w-screen-xl mx-auto px-6 py-14 lg:py-20">
      <ul class="grid grid-cols-1 md:grid-cols-3 gap-6 list-none p-0 m-0" role="list">
        <li v-for="t in topics" :key="t.slug">
          <router-link
            :to="`/keuzehulp/${t.slug}`"
            class="group flex flex-col h-full rounded-[18px] border border-[#e9eaec] bg-white p-7 no-underline transition-all hover:border-[#FFD500] hover:shadow-[0_10px_30px_rgba(0,0,0,0.07)] hover:-translate-y-1"
          >
            <span class="w-14 h-14 rounded-[14px] bg-[#fffbe6] text-[#111] flex items-center justify-center mb-5 group-hover:bg-[#FFD500] transition-colors">
              <i :class="['bi text-[1.6rem]', t.icon]" aria-hidden="true"></i>
            </span>
            <h2 class="text-[1.25rem] font-black text-[#111] mb-2">{{ t.title }}</h2>
            <p class="text-[0.95rem] text-[#666] leading-[1.6] mb-6 flex-1">{{ t.tagline }}</p>
            <span class="inline-flex items-center gap-2 text-[#111] font-bold text-[0.9rem] group-hover:gap-3 transition-all">
              Start de keuzehulp <i class="bi bi-arrow-right text-[#FFD500]" aria-hidden="true"></i>
            </span>
          </router-link>
        </li>
      </ul>

      <!-- Persoonlijk advies -->
      <div class="mt-12 rounded-[18px] bg-[#fafafa] border border-[#eee] p-7 sm:p-9 flex flex-col sm:flex-row items-start sm:items-center gap-5 justify-between">
        <div>
          <h3 class="text-[1.125rem] font-black text-[#111] mb-1">Liever persoonlijk advies?</h3>
          <p class="text-[0.95rem] text-[#666] m-0">Onze energiespecialisten denken gratis en vrijblijvend met je mee.</p>
        </div>
        <router-link to="/gratis-energieadvies" class="shrink-0 inline-flex items-center gap-2 bg-[#111] hover:bg-[#333] text-white font-bold text-[0.9rem] px-5 py-3 rounded-[10px] no-underline transition-colors">
          <i class="bi bi-chat-dots" aria-hidden="true"></i> Vraag gratis advies aan
        </router-link>
      </div>
    </section>
  </div>
</template>

<script setup>
import { KEUZEHULP_TOPICS } from '@/config/keuzehulp'
const topics = KEUZEHULP_TOPICS
</script>
